/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit, OnDestroy } from '@angular/core';
import { NbAuthService } from '@nebular/auth';
import * as Pubnub from 'pubnub';
import { NbToastrService } from '@nebular/theme';
import { environment } from '../environments/environment';
import { HelperService } from './services/helper.service';
import { CmoapiService } from './services/cmoapi.service';
import { Router } from '@angular/router';
import { MessageService } from './services/message.service';
import { ConstantProviderService } from './providers/constant-provider.service';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  
  //#region variables

  public loggedInUser = null;
  public pnbAlert: Pubnub;

  //#endregion

  //#region life cycle hook
  
  constructor(
    private authService: NbAuthService,
    private toasterService: NbToastrService,
    private cmoApiService: CmoapiService,
    private helper: HelperService,
    private router: Router,
    private messageService: MessageService,
    public constant: ConstantProviderService,
  ) {
    this.pnbAlert = new Pubnub({
      subscribeKey: environment.pubnub_real_time.sk
    });
    this.getMaintenanceMode();
  }

  ngOnInit(): void {
    this.authService.onAuthenticationChange().subscribe((auth: any) => {
      if (auth && localStorage.getItem('loggedInUser')) {
        this.addPubnubAlertListener();
      }
    });
  }

  //#endregion

  //#region private methods

  private addPubnubAlertListener() {
    this.loggedInUser = localStorage.getItem('loggedInUser');
    this.loggedInUser = this.loggedInUser.replace(/["]+/g, '');
    if (this.loggedInUser !== null) {
      this.pnbAlert.setUUID = this.loggedInUser;
      const channelName = `alert.${this.loggedInUser}`;
      this.pnbAlert.subscribe({
        channels: [channelName]
      });
      this.pnbAlert.addListener({
        message: (msg: Pubnub.MessageEvent) => {
          if (msg.message.type == 'NEW_ORDER_RECEIVED') {
            this.toasterService.success('New Order Received.', 'Hurray!');

          } else if (msg.message.type == 'ORDER_STATUS_UPDATED') {
            // this.toasterService.success('Order Status Updated', 'Hurray!');

          } else if (msg.message.type == 'STORE_IMPORT_SUCCESS') {
            this.toasterService.success('File Upload Status Updated', 'Hurray!');

          } else if (msg.message.type == 'ORDER_STATUS_DELYED') {
            this.router.navigate(['pages', 'orders', 'all', 'details', msg.message.data.order_id])
            this.toasterService.warning('Order Status Not Updated Yet', 'Hurray!');

          } else if (msg.message.type == 'MENU_ITEM_REQUEST_UPDATED') {
            this.router.navigate(['pages', 'menus', 'menu-editor'])
            this.toasterService.info(`Your given request for ${msg.message.data.request_type} was ${msg.message.data.request_status}`, 'Hurray!');
            
          } else if (msg.message.type == 'DISCOUNT_REQUEST_UPDATED') {
            this.router.navigate(['pages', 'discount', 'list'])
            this.toasterService.info(`Your given request for ${msg.message.data.request_type} was ${msg.message.data.request_status}`, 'Hurray!');
            
          } else if (msg.message.type == 'STORE_REQUEST_UPDATED') {
            this.router.navigate(['pages', 'stores', 'details', msg.message.data.store_id]);
            this.toasterService.info(`Your given request for ${msg.message.data.request_type} was ${msg.message.data.request_status}`, 'Hurray!');

          } else if (msg.message.type == 'PAUSE_DELIVERY_CANCELED') {
            // this.toasterService.info(`Pause delivery was canceled for ${msg.message.data.store_name}!!!`, 'Hurry!');
            this.messageService.sendMessage({ msg: 'Pause-Delivery', data: { _id: msg.message.data.store_id } });
          
          } else if (msg.message.type == 'SUBSCRIPTION_WEBHOOK_UPDATE') {
            // this.toasterService.info('Delivery setup details updated', 'Hurry!');
            this.cmoApiService.getAllStores(true, true).then((data: any) => {
              this.helper.removeAllStoresList();
              this.helper.setAllStoresList(data);
              if (localStorage.getItem('cmo-subscription')) {
                setTimeout(() => {
                  localStorage.removeItem('cmo-subscription')
                  this.helper.refreshComponent(window.location.pathname);
                }, 5000);
              }
            });
          
          } else if (msg.message.type == 'STAFF_STORE_UPDATED') {
            this.toasterService.danger(this.constant.PERMISSON_CHANGED, this.constant.ERROR);
            setTimeout(() => {
              this.helper.permissionChanged();
            }, 2000);
          }
        }
      })
    }
  }

  private getMaintenanceMode() {
    this.cmoApiService.getMaintenanceMode().subscribe((data: any) => {
      data.forEach((element: any) => {
        if (element.id == environment.MAINTENANCE_MODE_DOC) {
          if (element.status) { // mode status is true
            // if user logged in
            if (localStorage.getItem('chat-my-order:token')) {
              this.helper.clearLocalStorage();
            }
            this.router.navigate(['auth/maintenance-mode']);

          } else if (window.location.pathname.includes('maintenance-mode')) {
            this.router.navigate(['auth', 'login']);
          }
        }
      });
    });


  }

  //#endregion
}
